import * as Yup from 'yup';

export const totalExpenditureSchema = Yup.object().shape({
  min: Yup.number()
    .test({
      name: 'max',
      exclusive: false,
      params: {},
      test: (value, context) => {
        const { max } = context.parent;
        if (!max || !value) return true;
        return value <= max;
      },
    })
    .nullable(),
  max: Yup.string()
    .test({
      name: 'min',
      exclusive: false,
      params: {},
      test: (value, context) => {
        const { min } = context.parent;
        if (!min || !value) return true;
        return value >= min;
      },
    })
    .nullable(),
});

export const filtersValidationSchema = Yup.object().shape({
  totalExpenditure: Yup.object().shape({
    min: Yup.number()
      .test({
        name: 'max',
        exclusive: false,
        params: {},
        message: 'projectProposal.viewList.validation.min',
        test: (value, context) => {
          const { max } = context.parent;
          const maxValue = parseInt(max, 10);
          const minValue = parseInt(value, 10);
          if (!maxValue || !minValue) return true;
          return minValue <= maxValue;
        },
      })
      .nullable(),
    max: Yup.string()
      .test({
        name: 'min',
        exclusive: false,
        params: {},
        message: 'projectProposal.viewList.validation.max',
        test: (value, context) => {
          const maxValue = parseInt(value, 10);
          const { min } = context.parent;
          const minValue = parseInt(min, 10);
          if (!minValue || !maxValue) return true;
          return maxValue >= minValue;
        },
      })
      .nullable(),
  }),
  submittedAt: Yup.object().shape({
    start: Yup.string()
      .test({
        name: 'end',
        exclusive: false,
        params: {},
        message: 'projectProposal.viewList.validation.start',
        test: (value, context) => {
          const { end } = context.parent;
          if (!end) return true;

          const endDate = new Date(end).toLocaleDateString('en-ZA');
          const startDate = new Date(!value ? '1970-01-01Z00:00:00:000' : value).toLocaleDateString(
            'en-ZA'
          );
          return startDate < endDate;
        },
      })
      .nullable(),
    end: Yup.string()
      .test({
        name: 'start',
        exclusive: false,
        params: {},
        message: 'projectProposal.viewList.validation.end',
        test: (value, context) => {
          const { start } = context.parent;
          if (!start) return true;

          const startDate = new Date(start).toLocaleDateString('en-ZA');
          const endDate = new Date(!value ? '2100-01-01Z00:00:00:000' : value).toLocaleDateString(
            'en-ZA'
          );
          return startDate < endDate;
        },
      })
      .nullable(),
  }),
});

export const createRequestUpdateValidationSchema = Yup.object().shape({
  comment: Yup.string().required('projectProposal.requestUpdate.validationErrors.commentRequired'),
});

export const sendMailValidationSchema = Yup.object().shape({
  subject: Yup.string().required('projectProposal.sendMail.validationErrors.subjectRequired'),
  content: Yup.string()
    .required('projectProposal.sendMail.validationErrors.contentRequired')
    .nullable(),
});
